import { motion } from "framer-motion";
import { MapPin, Sparkles, BadgeCheck, Facebook } from "lucide-react";
import { LAUREN_URL } from "@/constants/assets";

const badges = [
  { icon: MapPin, label: "Locally owned & operated" },
  { icon: Sparkles, label: "Detail-obsessed cleans" },
  { icon: BadgeCheck, label: "Satisfaction promise" },
];

const Founder = () => (
  <section id="founder" className="py-20 md:py-28">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
      <motion.div
        initial={{ opacity: 0, x: -28 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7 }}
        className="relative mx-auto w-full max-w-md"
      >
        <div className="absolute -inset-4 border-2 border-[#990000]/25 rounded-[3rem] rotate-2" />
        <div className="relative rounded-[2.5rem] overflow-hidden border border-[#E5DEC9] shadow-2xl aspect-[4/5]">
          <img src={LAUREN_URL} alt="Lauren, founder of Tidy Tusks" data-testid="founder-section-image" className="w-full h-full object-cover" />
        </div>
      </motion.div>
      <motion.div
        initial={{ opacity: 0, x: 28 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7, delay: 0.1 }}
      >
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#990000] mb-3">Meet the founder</p>
        <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight leading-snug">
          Hi, I'm <span className="italic text-[#990000]">Lauren</span>.
        </h2>
        <div className="mt-6 space-y-4 text-base text-[#5C5955] leading-relaxed">
          <p>
            Tidy Tusks started with a mop, a bucket, and a stubborn belief: a clean home changes how you feel in it. What began as weekend cleans for neighbors has grown into a detail-obsessed cleaning service that I run personally, one home at a time.
          </p>
          <p>
            Every product I bring into your home is one I'd use in my own, and every clean ends with my personal quality checklist. I don't leave until it passes the white-glove test.
          </p>
        </div>
        <div className="mt-7 flex flex-wrap gap-3">
          {badges.map((b, i) => (
            <span key={i} data-testid={`founder-badge-${i}`} className="inline-flex items-center gap-2 bg-[#FDF0F0] text-[#990000] text-xs font-bold uppercase tracking-[0.12em] px-4 py-2.5 rounded-full border border-[#990000]/10">
              <b.icon size={14} /> {b.label}
            </span>
          ))}
        </div>
        <div className="mt-8 flex items-center gap-4">
          <p className="font-display italic text-3xl text-[#990000] -rotate-2">Lauren</p>
          <a
            href="https://www.facebook.com/share/14oBEKCkPvb/?mibextid=wwXIfr"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="founder-facebook-btn"
            aria-label="Tidy Tusks on Facebook"
            className="h-11 w-11 rounded-full bg-[#990000] text-white flex items-center justify-center shadow-md hover:bg-[#7A0000] hover:shadow-lg hover:-translate-y-0.5 hover:scale-105 transition-all duration-200"
          >
            <Facebook size={19} />
          </a>
        </div>
      </motion.div>
    </div>
  </section>
);

export default Founder;
